// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"e6091652","946":"96a3373b","959":"661d7664","996":"1692e348"}[chunkId] + ".chunk.js";
};